import styled from '@emotion/styled';
import { Menu } from 'antd';

export const StyledMenu = styled(Menu)`
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;
